/**
 * Per-workstream band highlight (MapWorkstreamBackgrounds.vue): the selected
 * workstream gets a full-width diagonal-stripe bluelight fill; the hovered one a
 * flat #f8f8f8 wash. The left 0–180 strip is later re-covered opaque by the
 * sidebar (SidebarPainter), exactly as the SVG sidebar sits over the bands.
 */
import { cssVar } from '../../draw/palette';
import { stripePattern } from '../../draw/shapes';
import type { SceneContext } from '../../engine/SceneContext';

export function drawBands(
  ctx: CanvasRenderingContext2D,
  scene: SceneContext,
): void {
  const { map, io } = scene;
  const hoveredId = map.hoveredWorkstream?.id;
  for (const ws of io.workstreams) {
    if (ws.isHiddenOnMap || map.filterHiddenWorkstreamIds.has(ws.id)) {
      continue;
    }
    const y = map.workstreamY(ws.id);
    const h = map.workstreamHeight(ws.id);
    if (map.isSelectedItem('workstream', ws.id)) {
      const pattern = stripePattern(ctx);
      ctx.save();
      if (pattern) {
        ctx.fillStyle = pattern;
      } else {
        ctx.globalAlpha = 0.3;
        ctx.fillStyle = cssVar('--color-bluelight-300', '#7CD4FD');
      }
      ctx.fillRect(0, y, scene.width, h);
      ctx.restore();
    } else if (hoveredId && hoveredId === ws.id) {
      ctx.save();
      ctx.fillStyle = '#f8f8f8';
      ctx.fillRect(0, y, scene.width, h);
      ctx.restore();
    }
  }
}
